import { Component, OnInit, OnDestroy } from '@angular/core';
import {AutoService} from '../../services/auto.service';
import {SearchService} from '../../services/search.service';
import {Auto} from '../auto/model/auto';
import {Search} from './model/search';
import {Observable} from 'rxjs/Rx';
import {HostListener} from '@angular/core';
import {ActivatedRoute, Router } from '@angular/router';
import {TinyService} from '../../services/tiny.service';
import {UserService} from '../../services/user.service';
import {CookieService} from 'ng2-cookies';
import { DataService } from "../../services/data.service";
import { Subscription } from 'rxjs';

@HostListener('window:keydown', ['$event'])
@Component({
  host: {
    '(document:keydown)': 'keyDown($event)',
  },
  selector: 'app-admin-search',
  templateUrl: './admin-search.component.html',
  styleUrls: ['./admin-search.component.css'],
})

export class AdminSearchComponent implements OnInit, OnDestroy {
  autos: Auto[];
  public searchs = new Search();
  public selectedAuto;
  searchText = "";
  subscription: Subscription;
  oldSearchText = "";
  selectedIndex = 0;
  show = true;
  showAuto = false;
  currentPage = 0;
  pageSize = 8;
  pageDirection = -1;
  totalCount = 0;
  pageCount = 0;
  working = false;
  counter = 0;
  start = 0;
  tin = "";
  theUser = "";

  constructor(private userSVC: UserService, private autoService: AutoService, private tinyService: TinyService, private searchService: SearchService, private activatedRoute: ActivatedRoute, private router: Router, private _cookieService:CookieService, private data: DataService) 
  {
  }

  ngOnInit() { 
    this.theUser = this.userSVC.authUser.email;
    if (!this.theUser) {
      this.router.navigate(['']);
    }

    this.activatedRoute.queryParams.subscribe(params => {
      this.searchText = params['q'] || "";
      var s = params['s'];
      this.start = + s || 0;
      this.tin = params['l'] || ""
      if (this.start == 0) {
        this.tiny();
      }

      if (this.searchText != "") {
        this.data.changeMessage(this.searchText);
      }

      this.subscription = this.data.currentMessage.subscribe(message => this.searchText = message)

      this.search();
    });
  }

   ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  auto() {
    //Use a queue for managing in-flight requests

    var res = this.searchText.trim().split(" ");
    var txt = res[res.length - 1];
    txt = txt.trim()
    var head  = this.searchText.substring(0,this.searchText.indexOf(txt)).trim();

    this.counter++;
    var thisCounter = this.counter;
    var timeoutId = setTimeout(()=> {
      this.showAuto = false;
      if (txt.length > 2) {
        this.autos = new Array();
        //TODO: [0] current auto textbox value
        //	let t = new Auto();
        //	 t.Name = this.searchText;
        //	 t.Rank = 0;
        //	 this.autos = new Array()
        //	 this.autos[0] = t;

        this.autoService.auto(txt)
          .subscribe(
            data => {
              //				this.autos = this.autos.concat(data); //Bind to view
              if (this.counter == thisCounter) {
                this.autos = data; //Bind to view
                if (this.autos.length > 0) {
                  this.showAuto = true;
                } else {
                  this.showAuto = false;
                }
                var i;
                for (i = 0; i < this.autos.length; i++) {
                  this.autos[i].Name = head  + " " + this.autos[i].Name;
                }
              }
            },
            err => {
              console.log(err);
            });
      } else {
        this.autos = new Array();
        this.showAuto = false;
      }	
    }, 1000/60);
    //	clearTimeout(timeoutId);
  }

  search() {
    this.showAuto = false;
    this.start = this.start % this.pageSize == 0 ? this.start : this.start - (this.start % this.pageSize);
    if (this.searchText != "" && this.searchText != this.oldSearchText) {
      this.searchs = new Search();
      this.totalCount = 0;
      this.pageCount = 0;
      this.show = false;
      this.working = true;
      this.data.changeMessage(this.searchText)

      this.searchService.search(this.searchText, this.start)
        .subscribe(
          data => {
            this.searchs = data; //Bind to view
            if(this.searchs.Results !== undefined) {
              this.totalCount = this.searchs.Total;
              this.pageSize = this.searchs.PageSize
              this.oldSearchText = this.searchText;
              this.pageCount = Math.ceil(this.totalCount / this.pageSize);
              this.start = this.searchs.Start;
              this.currentPage = (this.start + this.pageSize)/this.pageSize;
              this.working = false;
            }
          },
          err => {
            console.log(err);
            this.working = false;
          });
    }	
  }

  public selectAuto( auto: any, i: number) {
    this.selectedIndex = i;
    this.selectedAuto =  auto;
    this.searchText = this.selectedAuto.Name;
    this.setFirstPage()
    this.showAuto = false;
  }

  keyDown(event: any) {
    switch (event.keyCode) {
      case 38:
        this.onUp();
        event.preventDefault();
        break;
      case 40:
        this.onDown()
        event.preventDefault();
        break;
      case 13:
        this.setFirstPage()
        event.preventDefault();
        break;
    }
    return;
  }

  public onDown() {
    if(this.selectedIndex < this.autos.length - 1)
    {
      this.selectedAuto = this.autos[++this.selectedIndex];
      this.searchText = this.selectedAuto.Name;
    }
  }

  public onUp() {
    if(this.selectedIndex > 0)
    {
      this.selectedAuto = this.autos[--this.selectedIndex];
      this.searchText = this.selectedAuto.Name;
    }
  }

  tiny() {
    this.tin = "";
    this.tinyService.tiny()
      .subscribe(
        data => {
          this.tin = data.text().slice(1, -1);
        });
  }

  getCookie(key: string){
    return this._cookieService.get(key);
  }

  //pagination
  setFirstPage() {
    this.oldSearchText = "";
    this.start = 0;
    this.tiny();
    this.search();
  }

  setPreviousPage() {
    if(this.currentPage > 1) {
      this.oldSearchText = "";
      this.start = this.start - this.pageSize;
      this.search();
    }
  }

  setNextPage() {
    if (this.currentPage < this.pageCount) {
      this.oldSearchText = "";
      this.start = this.start + this.pageSize;
      this.search();
    }
  }

  setPage(page: number) {
    if (page >= 0 && page < this.pageCount) {
      this.oldSearchText = "";
      this.start = page * this.pageSize;
      this.search();
    }
  }

    /*
  //pagination
  setFirstPage() {
    if(this.searchText.length > 0) {
      this.oldSearchText = "";
      this.router.navigate(['/admin/search'],  { queryParams: { q : this.searchText, l : this.tin}});
    }
  }

  setPreviousPage() {
    if (this.currentPage > 1) {
      this.oldSearchText = "";
      this.router.navigate(['/admin/search'],  { queryParams: { q : this.searchText, s : (this.start - this.pageSize), l : this.tin}});
    }
  }

  setNextPage() {
    if (this.currentPage < this.pageCount) {
      this.oldSearchText = "";
      this.router.navigate(['/admin/search'],  { queryParams: { q : this.searchText, s : (this.start + this.pageSize), l : this.tin}});
    }
  }

  setPage(page: number) {
    if (page >= 0 && page < this.pageCount) {
      this.oldSearchText = "";
      this.router.navigate(['/admin/search'],  { queryParams: { q : this.searchText, s : (page * this.pageSize), l : this.tin}});
    }
  }
     */
}



// WEBPACK FOOTER //
// ./src/app/admin/adminSearch/admin-search.component.ts